const colors = {
  primary: "#4F39CF",
  success: "#46CF39",
  success100: "#FAFEF9",
  white: "#FFF",
  grey100: "#CCD2D8",
  blue100: "#021D3E",
  primary100: "#FAF9FF",
  primary200: "#DCD7F5",
  error: "#F44336",
  error100: "#FEF9F9" 
};
export default colors;
